import React, { useEffect } from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { Buffer } from "buffer";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { ApplicationBar } from "../features/appbar/ApplicationBar";
import { ChurchBar } from "../features/church/ChurchBar";
import { setChurch } from "../features/church/churchSlice";
import { Toolbar } from "../features/toolbar/Toolbar";
import { WorkTurnList } from "../features/workTurns/WorkTurnList";
import { Details } from "../features/details/Details";

const queryClient = new QueryClient();

const theme = createTheme({
  palette: {
    primary: {
      main: "#025D8F"
    }
  }
});

function WorkTurnListPage() {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const churchParam = searchParams.get("c");
    if (churchParam) {
      try {
        const churchData = JSON.parse(Buffer.from(churchParam, "base64").toString("utf-8"));
        if (churchData && churchData.id && churchData.name) {
          dispatch(setChurch(churchData));
        }
      } catch (error) {
        console.info("Failed to parse church parameter:", error);
      }
    }
  }, [searchParams, dispatch]);

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            minHeight: "100vh"
          }}
        >
          <ApplicationBar />
          <ChurchBar />
          <Toolbar />
          <WorkTurnList />
          <Details />
        </Box>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default WorkTurnListPage;
